import keywords,{getKeyGroup} from './keywords';
import PortApp from './PortApp.json';
import ShipApp from './ShipApp.json';

const version = process.env.NODE_VER;


const invYear = (lng)=>keywords.filter(o=>o.group=="invYear").map(o=>({...o,label:o[lng]}));
const scenario = (lng)=>keywords.filter(o=>o.group=="GPWV").map(o=>({...o,label:o[lng]}));
const province = (lng)=>keywords.filter(o=>o.group=="region").map(o=>({...o,label:o[lng]}));
const commodityType = (lng)=>keywords.filter(o=>o.group=="commodityType").map(o=>({...o,label:o[lng]}));
const equipmentType = (lng)=>keywords.filter(o=>o.group=="equipmentTypeAdmin").map(o=>({...o,label:o[lng]}));
const cheEquipmentType = (lng)=>keywords.filter(o=>o.group=="equipmentTypeCHE").map(o=>({...o,label:o[lng]}));
const retrofitType = (lng)=>keywords.filter(o=>o.group=="retrofit").map(o=>({...o,label:o[lng]}));
const powerUnits = (lng)=>keywords.filter(o=>o.group=="powerUnits").map(o=>({...o,label:o[lng]}));
const fuelType = (lng)=>keywords.filter(o=>o.group=="fuelType").map(o=>({...o,label:o[lng]}));
const intensity = (lng)=>keywords.filter(o=>o.group=="intensity").map(o=>({...o,label:o[lng]}));
const unitsTerminal = (lng)=>keywords.filter(o=>o.group=="unitsTerminal").map(o=>({...o,label:o[lng]}));
// const unitsAdmin = keywords.filter(o=>['unitMass','unitEnergy','unitVolume'].includes(o.group)).map(o=>({...o,label:o[lng]}));
const unitsAdmin = (lng)=>keywords.filter(o=>o.group=="units").map(o=>({...o,label:o[lng]}));
const vechicleType = (lng)=>keywords.filter(o=>o.group=="fleet").map(o=>({...o,label:o[lng]}));
const trainType = (lng)=>keywords.filter(o=>o.group=="serviceProvider").map(o=>({...o,label:o[lng]}));
const modelType = (lng)=>keywords.filter(o=>o.group=="modelType").map(o=>({...o,label:o[lng]}));
const trainFuelType = (lng)=>keywords.filter(o=>o.group=="fuelTypeTrain").map(o=>({...o,label:o[lng]}));
const fuelTypeCHE = (lng)=>keywords.filter(o=>o.group=="fuelTypeCHE").map(o=>({...o,label:o[lng]}));
const fuelTypeHighwayVeh = (lng)=>keywords.filter(o=>o.group=="fuelTypeHighwayVeh").map(o=>({...o,label:o[lng]}));
const fuelTypeFacilityVeh = (lng)=>keywords.filter(o=>o.group=="fuelTypeFacilityVeh").map(o=>({...o,label:o[lng]}));


const workType = (lng)=>keywords.filter(o=>o.group=="workDone").map(o=>({...o,label:o[lng]}));
const ownership = (lng)=>keywords.filter(o=>o.group=="trainOwnership").map(o=>({...o,label:o[lng]}));
const trainAgeProfile = (lng)=>keywords.filter(o=>o.group=="trainAgeProfile").map(o=>({...o,label:o[lng]}));

const ports = (lng)=>keywords.filter(o=>o.group=="port").map(o=>({...o,label:o[lng]}));

export const tables=[
  // {"id":"ADMIN_Link_EmisFactors","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/ADMIN_Link_EmisFactors.csv`,"custom":undefined},
  {"id":"CHE_Link_EmisFactors","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/CHE_Link_EmisFactors.csv`,"custom":undefined,disabled:false},
  {"id":"GEN_Link_BioGHG_EmisFactors","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/GEN_Link_BioGHG_EmisFactors.csv`,"custom":undefined,disabled:false},
  {"id":"GEN_Link_Biofuel_RegionFactors","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/GEN_Link_Biofuel_RegionFactors.csv`,"custom":undefined,disabled:false},
  {"id":"GEN_Link_Egrid","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/GEN_Link_Egrid.csv`,"custom":undefined,disabled:false},
  {"id":"GEN_Link_FuelSulphur","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/GEN_Link_FuelSulphur.csv`,"custom":undefined,disabled:false},
  {"id":"MOB_Link_DefaultAgeProfiles","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/MOB_Link_DefaultAgeProfiles.csv`,"custom":undefined,disabled:false},
  {"id":"MOB_Link_EmisFactors","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/MOB_Link_EmisFactors.csv`,"custom":undefined,disabled:false},
  {"id":"RAIL_EFs","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_EFs.csv`,"custom":undefined,disabled:false},
  {"id":"RAIL_Fuel_Index","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Fuel_Index.csv`,"custom":undefined,disabled:false},
  {"id":"RAIL_Loco_Hourly","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Loco_Hourly.csv`,"custom":undefined,disabled:false},
  {"id":"RAIL_Operator","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Operator.csv`,"custom":undefined,disabled:true},
  {"id":"RAIL_Tier","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Tier.csv`,"custom":undefined,disabled:true},
  {"id":"RAIL_Tier_Split","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Tier_Split.csv`,"custom":undefined,disabled:true},
  {"id":"RAIL_Work_Index","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/RAIL_Work_Index.csv`,"custom":undefined,disabled:false},
  {"id":"Type_ADMIN_Equip","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_ADMIN_Equip.csv`,"custom":undefined,disabled:true},
  {"id":"Type_CHE_Equip","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_CHE_Equip.csv`,"custom":undefined,disabled:true},
  {"id":"Type_GEN_Fuel","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_GEN_Fuel.csv`,"custom":undefined,disabled:true},
  {"id":"Type_GEN_GlobalWarmingPotential","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_GEN_GlobalWarmingPotential.csv`,"custom":undefined,disabled:true},
  {"id":"Type_GEN_RegionalLocation","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_GEN_RegionalLocation.csv`,"custom":undefined,disabled:true},
  {"id":"Type_GEN_Substances","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_GEN_Substances.csv`,"custom":undefined,disabled:true},
  {"id":"Type_MOB_AgeProfile","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_MOB_AgeProfile.csv`,"custom":undefined,disabled:true},
  {"id":"Type_MOB_Fleet","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_MOB_Fleet.csv`,"custom":undefined,disabled:true},
  {"id":"Type_MOB_Intensity","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_MOB_Intensity.csv`,"custom":undefined,disabled:true},
  {"id":"Type_RAIL_Model","default":`https://peit-oiep.s3.amazonaws.com/public/${version}/assets/Type_RAIL_Model.csv`,"custom":undefined,disabled:true},  
]

const getLabelFromDataKey=(array,data,selectedKey)=>array.find(o=>o.key==data?.value?.fuel.find(({id})=>id==selectedKey)?.fuelType)?.label;
const getLabelFromKey=(array,key)=>array.find(o=>o.key==key)?.label;



// const Port_Code = [...new Set(PortApp.map((array,i)=>array[1]))];
// const Ports = ({onChange})=>Port_Code.map(code=>({
//         label: <span style={{cursor:"pointer"}} onClick={()=>onChange(PortApp.filter(o=>o[1]==code).map(o=>o[0]))}>{code}</span>,
//         options: PortApp.filter(o=>o[1]==code).map((o,i)=>({value:o[0],label:o[0]}))        
//       })

// )

const Ships = ShipApp.map((o,i)=>({key:o[0],value:o[0],label:o[1]}))       

const getShipLabel = (a,b,lng)=>{
  
  const ship=Ships.find(o=>o.key==b)
  
  if(ship){
    return `${ship.label} (${ship.key})`
  }
  return null
}
export const getDefaultLayout=()=>{
  return {
    "xs": [
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 0,
            "i": "0",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 0,
            "i": "1",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 1,
            "i": "2",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 1,
            "i": "3",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 2,
            "i": "4",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 1,
            "y": 2,
            "i": "5",
            "moved": false,
            "static": false
        }
    ],
    "lg": [
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 0,
            "i": "0",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 0,
            "i": "1",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 2,
            "y": 0,
            "i": "2",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 2,
            "y": 1,
            "i": "3",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 1,
            "y": 1,
            "i": "4",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 1,
            "i": "5",
            "moved": false,
            "static": false
        }
    ],
    "sm": [
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 0,
            "i": "0",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 0,
            "i": "1",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 1,
            "i": "2",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 1,
            "i": "3",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 2,
            "i": "4",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 1,
            "y": 2,
            "i": "5",
            "moved": false,
            "static": false
        }
    ],
    "xxs": [
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 0,
            "i": "0",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 1,
            "i": "1",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 2,
            "i": "2",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 3,
            "i": "3",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 4,
            "i": "4",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 5,
            "i": "5",
            "moved": false,
            "static": false
        }
    ],
    "md": [
        {
            "w": 1,
            "h": 1,
            "x": 0,
            "y": 0,
            "i": "0",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 1,
            "y": 0,
            "i": "1",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 2,
            "y": 0,
            "i": "2",
            "moved": false,
            "static": false
        },
        {
            "w": 2,
            "h": 1,
            "x": 0,
            "y": 1,
            "i": "3",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 1,
            "y": 1,
            "i": "4",
            "moved": false,
            "static": false
        },
        {
            "w": 1,
            "h": 1,
            "x": 2,
            "y": 1,
            "i": "5",
            "moved": false,
            "static": false
        }
    ]
}
}


export default  ({lng="en"})=>{
  const newLabels =getKeyGroup(lng);
  const _fuelType=fuelType(lng)
  const getFuelTypeBasedOnEquipment=(equipment)=>{
    return equipment=="Gen"?_fuelType.filter(o=>["Dies","Gas","Prop","NatG"].includes(o.key)):
    equipment=="Boil"?_fuelType.filter(o=>["NatG"].includes(o.key)):
    _fuelType.filter(o=>["Elec"].includes(o.key))
  }
  
  return {
  "type":"array",
  "meta":{"ui":"bread"},
  "items":{
    "type": "object",  
    "meta":{"ui":"cardradio"},
    "properties": {
      "id": {
        "label":newLabels?.app?.id,
        "type": "string",
        "format": "uuid",
        "hidden":true,
        "hide":true,
      },
      "name": {
        "label":newLabels?.app?.name,
        "type": "string",      
      },    
      "isSave": {
        "type":"boolean",
        "label":newLabels?.app?.isSave,
        "hidden":true,
        "hide":true,        
      },
      "submitted": {
        "type":"boolean",
        "label":newLabels?.app?.submitted,
        "hidden":true,
        "hide":true,        
      },
      "radioKey": {        
        "type":"string",
        "hidden":true,
        "hide":true,        
      },
       
      "notes": {
        "label":newLabels?.app?.notes,
        "type": "string",
        
      },
      "input":{
        "type": "object",
        "hide":true,        
        "label":newLabels?.app?.input,
        "meta":{"ui":"tabs"},
        "properties": {
          "introduction": {
            "formTitle":newLabels?.app?.introduction,
            "type": "object",
            "label":newLabels?.app?.introduction,
            
            "meta":{"ui":"card"},
            "properties": {        
              // "terminalName": {
              //   "label":newLabels?.introduction?.terminalName,
              //   "type": "string",                
              // },
                "invYear": {
                "label":newLabels?.introduction?.invYear,
                "info":newLabels?.introHint?.InvYearDesc,
                "tooltip":newLabels?.introHint?.InvYearDesc,
                "type": "string",                
                "options": invYear(lng)
              },
              "province": {
                "label":newLabels?.introduction?.province,
                "info":newLabels?.introHint?.ProvDesc,
                "tooltip":newLabels?.introHint?.ProvDesc,
                "type": "string",
                "showSearch":true,
               
                "options": province(lng)
              },              
              "portAuthority": {
                "label":newLabels?.introduction?.portAuthority,
                "info":newLabels?.introHint?.PortAuthDesc,
                "tooltip":newLabels?.introHint?.PortAuthDesc,
                "type": "string",
                "options": ports(lng)
                
              },
              "scenario": {
                "label":newLabels?.introduction?.scenario,
                "info":newLabels?.introHint?.GlobalWarmDesc,
                "tooltip":newLabels?.introHint?.GlobalWarmDesc,
                "type": "string",
                "options": scenario(lng)
                
              },
              // "isAdmin": {
              //   "label":newLabels?.introduction?.isAdmin,
              //   "type": "boolean"
              // },

              // "notes": {
              // "label":newLabels?.introduction?.notes,
              // "type": "string"
              // }
            },
            "required": ["terminalName", "invYear", "portAuthority", "province","scenario"]
          },
          "terminal": {
              "type": "array",
              "hidden":true,
              "label":newLabels?.app?.terminal,
              
              "labelExtra":newLabels?.app?.terminaltitle,
              "meta":{"ui":"editD"},
              "directEdit":true,
              "items": {
              "type": "object",
              "properties": {
                "id": {
                  "label":newLabels?.terminal?.id,
                  "hidden":true,
                  "type": "string",
                  "format":"uuid",
                  // "hidden":true,
                },
                "commodityType": {                  
                  "label":newLabels?.terminal?.commodityType,
                  "info":newLabels?.terminalHint?.CommodityTypeDesc,
                  "type": "string",
                  "options": commodityType(lng) 
                },
                "annualThroughput": {
                  "label":newLabels?.terminal?.annualThroughput,
                  "info":newLabels?.terminalHint?.AnnualThroughputDesc,
                  "type": "number",
                  "step":0.1,
                  "min": 0,
                },
                "units": {
                  "label":newLabels?.terminal?.units,
                  "info":newLabels?.terminalHint?.UnitsMeasureDesc,
                  "type": "string",
                  "options":  unitsTerminal(lng) 
                },
                "notes": {
                  "label":newLabels?.terminal?.notes,
                  "type": "string"
                }
              },
              "required": ["commodityType", "annualThroughput", "units"]   
                }
          },
          "admin": {
             "type": "array",
             "hidden":true,
             "label":newLabels?.app?.admin,
               "labelExtra":newLabels?.app?.admintitle,
             "meta":{"ui":"editD"},
                "items": {
            
            "type": "object",
            "onValuesChange":(form,value,values)=>form.validateFields(),
            "properties": {
                   "id": {
                      // "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format":"uuid",
                      "hidden":true,
                      },
                    "equipmentType": {
                      "group":"equipmentTypeAdmin",
                      "label":newLabels?.admin?.equipmentType,
                      "info":newLabels?.adminHint?.EnergyEquipDesc,
                      "type": "string",
                      "options":  equipmentType(lng), 
                       
                    },
                    "fuelType": {
                      "label":newLabels?.admin?.fuelType,
                      "info":newLabels?.adminHint?.FuelTypeDesc,
                      "type": "string",
                      "options":(o,p)=>p&&p.equipmentType?getFuelTypeBasedOnEquipment(p.equipmentType):[]||[],
                      // "options":_fuelType,
                      "defaultOptions":[],
                      // "dependencies":["equipmentType"],
                      // "getOptions":(o)=>[],
                      "shouldUpdate":true,
                      // "shouldUpdate":(prev,curr)=>curr.equipmentType!==prev.equipmentType||curr.fuelType!==prev.fuelType,
                      // "getOptionsWithRowData":(getFieldValue)=>getFuelTypeBasedOnEquipment(getFieldValue("equipmentType"))
                    },                    
                    "totalAnnualConsumption": {
                      "label":newLabels?.admin?.totalAnnualConsumption,
                      "info":newLabels?.adminHint?.TotalConsDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0.0,
                    },
                    "units": {
                      "label":newLabels?.admin?.units,
                      "info":newLabels?.adminHint?.UnitsMeasureDesc,
                      "type": "string",
                      "options": unitsAdmin(lng)
                    },
                    "notes": {
                       "label":newLabels?.admin?.notes,
                      "type": "string"
                    }
                  },
            "required": ["fuelType", "equipmentType", "totalAnnualConsumption", "units"]
                }
              
      
          },
          "marine": {
            "label":newLabels?.app?.marine,
            "info":newLabels?.marineHint?.ZoneDesc,
            "type": "object",
            "hidden":true,
            "meta":{"ui":"editMap"},
            "properties": {
              "zone": {
                "label":newLabels?.marine?.zone,
                "type": "array",                
                // "meta":{"ui":"editMap"},
                "items": {
                  "type": "object",
                  "properties": {
                    "id": {
                       "label":newLabels?.marine?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    // "visible": {
                    //   "label":newLabels?.marine?.visible,
                    //   "type": "boolean",
                    //   "label":"",
                    //   "hide":true,
                    //   "showEdit":true,                      
                    // },
                    "active": {
                      "label":newLabels?.marine?.active,
                      "type": "boolean",                                            
                      "showEdit":true,                      
                    },
                    "name": {
                      "label":newLabels?.marine?.name,
                         
                      "type": "string"
                    },
                    "color": {
                      "label":newLabels?.marine?.color,
                      "type": "string",
                      "format":"hex",                      
                      "hide":true,
                      "showEdit":true,
                    },
                    // "locations":{
                    //   "label":newLabels?.marine?.locations ??"Locations",
                    //   "type": "selectExtent",
                      
                    //   "moptions":Ports,
                    //   "minWidth":"200px"
                      
                                                                                                              
                    //   },
                    // "ships":{
                    //   "label":newLabels?.marine?.ships ??"Ships",
                    //   "type": "select",
                      
                    //   "moptions":Ships,
                    //   "minWidth":"200px",
                    //   "placeholder":"All ships"
                      
                                                                                                              
                    //   },
                                     
                    "polygon": {
                      "label":newLabels?.marine?.polygon,
                      "type": "string",
                      "hide":true,
                      "hidden":true,
                    }
                  },
                  "required": ["id", "name","color"]
                }
              },
              "location": {
                "label":newLabels?.marine?.location,
                "info":newLabels?.marineHint?.BerthAncDesc,
                
                "type": "array",                
                "meta":{"ui":"editMap"},
                "items": {
                  "type": "object",
                  "properties": {
                    "id": {
                       "label":newLabels?.marine?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                     "zoneId": {
                      "label":newLabels?.marine?.zoneId,
                      "info":newLabels?.marineHint?.MarineZoneDesc,
                      "type": "string",
                      "options":(o)=>(o?.value?.zone.map(({id,name})=>({id,key:id,label:name})) ??[]),
                      "getValue":(data,selectedKey)=>data?.value?.zone?.find(({id,name})=>id==selectedKey)?.name,
                       
                    },
                    // "visible": {
                    //   "label":newLabels?.marine?.visible,
                    //   "type": "boolean",
                    //   "label":"",
                    //   "hide":true,
                    //   "showEdit":true,                      
                    // },
                    "active": {
                      "label":newLabels?.marine?.active,
                      "type": "boolean",                                            
                      "showEdit":true,                      
                    },
                    "name": {
                      "label":newLabels?.marine?.name,
                      
                      "type": "string"
                    },
                    "color": {
                      "label":newLabels?.marine?.color,
                      "type": "string",
                      "format":"hex",                      
                      "hide":true,
                      "showEdit":true,
                    },
                     
                    "polygon": {
                      "label":newLabels?.marine?.polygon,
                      "type": "string",
                      "hide":true,
                      "hidden":true,
                    }
                  },
                  "required": ["id","zoneId", "name","color"]
                }
              },
              "vessel": {
                
                "label":newLabels?.marine?.Vessel,
               "info":newLabels?.marineHint?.ShipListDesc,
                "type": "array",
                "title":"Vessels",
                "meta":{"ui":"table"},
                "items": {
                  "type": "object",
                  "properties": {
                    // "id": {
                    //   "hidden":true,
                    //   "label":newLabels?.marine?.id,
                    //   "type": "string",
                    //   "format": "uuid"
                    // },
                    // "imo": {
                    //   "label":newLabels?.marine?.imo,
                    //   "type": "string"
                    // },
                    // "vesselName": {
                    //   "label":newLabels?.marine?.vesselName,
                    //   "type": "string",
                    //   "hidden":true,
                    // },
                    "shipId": {
                      "label":newLabels?.marine?.ship ??"Ship", 
                      "info":newLabels?.marineHint?.ShipListDesc,
                      "type": "string",                      
                      "options":Ships,
                      "minWidth":"200px",
                      showFilters:false,
                      optionFilterProp:"label",
                      filterOption:(input, option) =>option?.children.toLowerCase().includes(input.toLowerCase())  ,
                       "showSearch":true,
                      "getValue":(a,b)=>getShipLabel(a,b,lng)
                      // "placeholder":"All ships"
                       
                    },   
                    
                  },
                  "required": ["shipId"]
                }
              }
            },
            "required": ["zone"]
          },
          "che": {
            "label":newLabels?.app?.che,
            "type": "object",
            "hidden":true,
            "meta":{"ui":"card"},
            "properties": {
              "fuel": {
                "label":newLabels?.cheH?.fuel,
                "type": "array",
                 "meta":{"ui":"editD"},
                "items": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "hidden":true,
                      "label":newLabels?.che?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "fuelType": {
                      "label":newLabels?.che?.fuelType,
                      "info":newLabels?.cheHint?.FuelTypeDesc,
                      "type": "string",
                      "options": fuelTypeCHE(lng)
                    },
                    "annualFuel": {
                      "label":newLabels?.che?.annualFuel,
                      "info":newLabels?.cheHint?.AnnualConsDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "units": {
                      "label":newLabels?.che?.units,
                      "info":newLabels?.cheHint?.UnitsFuelDesc,
                      "type": "string",
                      "options":  unitsAdmin(lng) 
                    },
                    "notes": {
                      "label":newLabels?.che?.notes,
                      "type": "string"
                    }
                  },
                  "required": ["id", "fuelType", "annualFuel", "units"]
                }
              },
              "equipment": {
                 "label":newLabels?.cheH?.equipment,
                "type": "array",
                 "meta":{"ui":"editD"},
                "items": {
                  "type": "object",
                  "properties": {
                     "id": {
                      "hidden":true,
                      "label":newLabels?.che?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "equipmentType": {
                      "label":newLabels?.che?.equipmentType,
                      "info":newLabels?.cheHint?.EquipTypeDesc,
                      "group":"equipmentTypeCHE",
                      "type": "string",
                      "options":cheEquipmentType(lng) 
                      // "getOptions":(o)=>console.log(o)||(o?.value?.fuel.map(({id,fuelType})=>({id,key:id,label:fuelType})) ??[]),
                    },
                    "modelYear": {
                      "label":newLabels?.che?.modelYear,
                      "info":newLabels?.cheHint?.ModelYearDesc,
                      "type": "integer",
                      "min": 1942,
                      "max": 2023
                    },
                    "similarUnits": {
                       "label":newLabels?.che?.similarUnits,
                       "info":newLabels?.cheHint?.SimilarUnitsDesc,
                      "type": "integer",
                      "min": 0,
                      
                    },
                    "isRetrofit": {
                      "hidden":true,
                      "label":newLabels?.che?.isRetrofit,
                      "info":newLabels?.cheHint?.RetrofitDesc,
                      "type": "boolean"
                    },
                    "retrofitType": {
                      "hidden":true,
                       "label":newLabels?.che?.retrofitType,
                       "info":newLabels?.cheHint?.RetrofitTypeDesc,
                       "group":"retrofit",
                      "type": "string",
                       "options":  retrofitType(lng) 
                    },
                    "fuelId": {
                       "label":newLabels?.che?.fuelId,
                       "info":newLabels?.cheHint?.FuelTypeRefDesc,
                       "group":"fuelType",
                       "type": "string",                      
                       "options":(o)=>(o?.value?.fuel?.map(({id,fuelType:ft})=>({id,key:id,label:getLabelFromKey(fuelTypeCHE(lng),ft)})) ??[]),
                       "getValue":(data,selectedKey)=>getLabelFromDataKey(fuelTypeCHE(lng),data,selectedKey)
                    },
                    "enginePower": {
                       "label":newLabels?.che?.enginePower,
                       "info":newLabels?.cheHint?.EngPowerDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "powerUnits": {    
                       "label":newLabels?.che?.powerUnits,
                       "info":newLabels?.cheHint?.PowerUnitsDesc,
                      "type": "string",
                       "options":powerUnits(lng) 
                    },
                    "annualHours": {
                       "label":newLabels?.che?.annualHours,
                       "info":newLabels?.cheHint?.AnnualHoursDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                     "notes": {
                      "label":newLabels?.che?.notes,
                      "type": "string"
                    }
                  },
                  "required": ["equipmentType", "modelYear", "units", "retrofitType", "fuelId", "enginePower", "powerUnits", "annualHours","similarUnits"]
                }
              }
            },
            "required": ["fuel", "equipment"]
          },
          "road": {
            "label":newLabels?.app?.road,
            "type": "object",
            "hidden":true,
            "meta":{"ui":"card"},
            "properties": {
              "highwayVehicles": {
                "label":newLabels?.roadH?.highway,
                "type": "array",
                "meta":{"ui":"editD"},
                "modalWidth":800,
                "items": {
                  
                  "type": "object",
                  "properties": {  
                   "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "vehicleType": {
                      "label":newLabels?.road?.vehicleType,
                      "info":newLabels?.roadHint?.VehicleTypeDesc,
                      "type": "string",
                      "group":"fleet",
                      "options": vechicleType(lng)
                      
                    },
                    "fuelType": {
                        "label":newLabels?.road?.fuelType,
                        "info":newLabels?.roadHint?.FuelTypeDesc,
                      "type": "string",
                      "options": fuelTypeHighwayVeh(lng)
                    },
                    "annualGateCounts": {
                        "label":newLabels?.road?.annualGateCounts,
                        "info":newLabels?.roadHint?.AnnualGateDesc,
                      "type": "number",
                      "min": 0,
                    },
                    "cTime": {
                        "label":newLabels?.road?.cTime,
                        "info":newLabels?.roadHint?.AvgTimeAtDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "cDriving": {
                        "label":newLabels?.road?.cDriving,
                        "info":newLabels?.roadHint?.AvgTimeDriveDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "cIdling": {
                        "label":newLabels?.road?.cIdling,
                        "info":newLabels?.roadHint?.AvgTimeIdleDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "ageProfile": {
                      "label":newLabels?.road?.ageProfile,
                      "info":newLabels?.roadHint?.AgeProfileDesc,
                      "type": "string",                      
                      "options":(o)=>(o?.value?.custom?.map(({id,name})=>({id,key:id,label:name})) ??[]),
                      "getValue":(data,selectedKey)=>(data?.value?.custom.find(({id})=>id==selectedKey)?.name),
                    },
                    "dEntry": {
                        "label":newLabels?.road?.dEntry,
                        "info":newLabels?.roadHint?.DistEntryDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "dExit": {
                        "label":newLabels?.road?.dExit,
                        "info":newLabels?.roadHint?.DistExitDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "dIdling": {
                        "label":newLabels?.road?.dIdling,
                        "info":newLabels?.roadHint?.AvgTimeIdlePortDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "dSpeed": {
                        "label":newLabels?.road?.dSpeed,
                        "info":newLabels?.roadHint?.AvgSpeedPortDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "notes": {
                      "label":newLabels?.road?.notes,
                      "type": "string"
                    }
                  },
                  "required": ["vehicleType","fuelType", "annualGateCounts", "cTime", "cDriving", "cIdling", "ageProfile", "dEntry", "dExit", "dIdling", "dSpeed"]
                }
              },
              "fuel": {
                "label":newLabels?.roadH?.fuel,
                "type": "array",
                 "meta":{"ui":"editD"},
                "items": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "fuelType": {
                      "label":newLabels?.road?.fuelType,
                      "info":newLabels?.roadHint?.FuelTypeDesc,
                      "type": "string",
                      "options":  fuelTypeFacilityVeh(lng)
                    },
                    "annualFuel": {
                      "label":newLabels?.road?.annualFuel,
                      "info":newLabels?.roadHint?.AnnualFuelConsDesc,
                      "type": "number",
                      "step":0.1,
                      "min": 0,
                    },
                    "units": {
                      "label":newLabels?.road?.units,
                      "info":newLabels?.roadHint?.UnitsFuelDesc,
                      "type": "string",
                      "options": unitsAdmin(lng) 
                    },
                    "notes": {
                      "label":newLabels?.road?.notes,
                      "type": "string"
                    }
                  },
                  "required": ["id", "fuelType", "annualFuel", "units"]
                }
              },
              "vehicles": {
                "label":newLabels?.roadH?.vehicle,
                "type": "array",
                 "meta":{"ui":"editD"},
                "items": {
                  
                  "type": "object",
                  "properties": {
                     "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "vehicleType": {
                      "label":newLabels?.road?.vehicleType,
                      "info":newLabels?.roadHint?.VehicleTypeDesc,
                      "type": "string",
                      "group":"fleet",
                      "options": vechicleType(lng)
                      
                    },
                    "modelYear": {
                       "label":newLabels?.road?.modelYear,
                       "info":newLabels?.roadHint?.VehicleModelDesc,
                      "type": "integer",
                      "min": 1980,
                      "max": 2023
                    },
                    "numberVechicles": {
                       "label":newLabels?.road?.numberVechicles,
                       "info":newLabels?.roadHint?.SimilarVehicleDesc,
                      "type": "integer",
                      "min": 0,
                      
                    },
                    "intensity": {
                       "label":newLabels?.road?.intensity,
                       "info":newLabels?.roadHint?.IntensityUseDesc,
                      "type": "string",
                      "options": intensity(lng) 
                    },
                    "fuelId": {
                       "label":newLabels?.road?.fuelId,
                       "info":newLabels?.roadHint?.FuelTypeRefDesc,
                      "type": "string",
                      // "getOptions":(o)=>o?.value?.fuel.map(({id,fuelType})=>({id,key:id,label:fuelType})) ??[],
                      // "getValue":(data,selectedKey)=>data?.value?.fuel.find(({id})=>id==selectedKey)?.fuelType,
                      "options":(o)=>(o?.value?.fuel?.map(({id,fuelType:ft})=>({id,key:id,label:getLabelFromKey(fuelTypeFacilityVeh(lng),ft)})) ??[]),
                      "getValue":(data,selectedKey)=>getLabelFromDataKey(fuelTypeFacilityVeh(lng),data,selectedKey)
                      
                    },
                    "notes": {
                      "label":newLabels?.road?.notes,
                      "type": "string"
                    }
                  },
                  "required": ["vehicleType", "modelYear", "numberVechicles","units", "intensity", "fuelId"]
                }
              },
              
              "custom": {
                "show":true,
                "label":newLabels?.roadH?.profile,
                "info":newLabels?.roadHint?.AgeProfileTitleDesc,
                // "info":newLabels?.ageProfileDesc,
                // "label":"Age Profile",
                "type": "array",
                "meta":{"ui":"breadGeneral"},
                "items": {
                  "type": "object",                  
                  "meta":{"ui":"ageprofile"},
                  "showExtra":false,
                  "properties": {
                     "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                    "name":{
                       "label":newLabels?.road?.name,
                      "type": "string",
                    },
                    "notes":{
                      "label":newLabels?.road?.notes,
                      "type": "string",
                      "hidden":true,
                    },
                    "data":{
                      "type": "array",
                      "meta":{"ui":"editD"},
                      // "hide":true,
                      "hidden":true,
                      "items":{
                        "type":"object",
                        "required": ["age","number", "percentage"],
                        "properties": {                                                                        
                          "id":{
                                                  "hidden":true,
                            "label":newLabels?.app?.id,
                            "type": "string",
                            "format": "uuid"
                          },
                          "age":{
                            "label":newLabels?.road?.age,
                            "type": "integer",
                            "min": 0,
                            "max": 30
                          },
                          "number": {
                             "label":newLabels?.road?.number,
                            "type": "number",
                            "min": 0,
                          },
                          "percentage": {
                             "label":newLabels?.road?.percentage,
                            "type": "number",
                            "step":0.1,
                            "min": 0,
                          }             
                        }
                      }
                    }
                  }
                }
              }
            }
           
          },
          "rail":{      
            "label":newLabels?.app?.rail,
            "type": "object",
            "hidden":true,
            "meta":{"ui":"card"},
            "properties":{
              "national": {
                "label":newLabels?.rail?.national,
                "type": "array",
                 "meta":{"ui":"editD"},
               "modalWidth":700,
            "items": {
              "type": "object",
              "properties": {
                     "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                  "serviceProvider": {
                    "label":newLabels?.rail?.serviceProvider,
                    "info":newLabels?.railHint?.ServiceProviderDesc,
                    "type": "string",
                     "options":  trainType(lng) 
                  },
                  "annualTrainVisits": {
                    "label":newLabels?.rail?.annualTrainVisits,
                    "info":newLabels?.railHint?.AnnualTrainVisitsDesc,
                    "type": "integer",
                    "min": 0,
                  },
                  "averageInbound": {
                    "label":newLabels?.rail?.averageInbound,
                    "info":newLabels?.railHint?.AvgTrainTonnageInboundDesc,
                    "type": "number",
                    "step":0.1,
                    "min": 0,
                  },
                  "averageOutbound": {
                    "label":newLabels?.rail?.averageOutbound,
                    "info":newLabels?.railHint?.AvgTrainTonnageOutboundDesc,
                    "type": "number",
                    "step":0.1,
                    "min": 0,
                  },
                  "distanceTerminalPort": {
                    "label":newLabels?.rail?.distanceTerminalPort,
                    "info":newLabels?.railHint?.DistPortTerminalDesc,
                    "type": "number",
                    "step":0.1,
                    "min": 0,
                  },
                  "timeSpent": {
                    "label":newLabels?.rail?.timeSpent,
                    "info":newLabels?.railHint?.AvgTimeTerminalDesc,
                    "type": "number",
                    "step":0.1,
                    "min": 0,
                  },
                  "workDone": {
                    "label":newLabels?.rail?.workDone,
                    "info":newLabels?.railHint?.WorkTerminalDesc,
                    "type": "string",
                     "options": workType(lng) 
                  },
                    "notes": {
                      "label":newLabels?.rail?.notes,
                      "info":newLabels?.railHint?.NotesDesc1,
                      "type": "string",
                       
                  }
                },
                "required": ["serviceProvider", "annualTrainVisits", "averageInbound", "averageOutbound", "distanceTerminalPort", "timeSpent", "workDone"]
            }
          },
              "facility": {
                "label":newLabels?.rail?.facility,
                "type": "array",                

                "meta":{"ui":"editD"},
            "items": {
              
                "type": "object",
                "properties": {
                     "id": {
                      "hidden":true,
                      "label":newLabels?.app?.id,
                      "type": "string",
                      "format": "uuid"
                    },
                  "ownership": {
                    "label":newLabels?.rail?.ownership,
                    "info":newLabels?.railHint?.OwnershipDesc,
                    "type": "string",
                    "group":"trainOwnership",
                    "options":  ownership(lng) 
                    
                  },
                  "model": {
                    "label":newLabels?.rail?.model,
                    "info":newLabels?.railHint?.ModelDesc,
                    "type": "string",
                    "group":"modelType",
                    "options":  modelType(lng) 
                  },
                  "engineYear": {
                    "label":newLabels?.rail?.engineYear,
                    "info":newLabels?.railHint?.EngineYearDesc,
                    "type": "string",
                    "group":"trainAgeProfile",
                    "options":  trainAgeProfile(lng)                                       
                  },
                  "fuelTypeTrain": {
                    "label":newLabels?.rail?.fuelTypeTrain,
                    "info":newLabels?.railHint?.FuelTypeDesc,
                    "type": "string",                    
                     "options":  trainFuelType(lng) 
                  },
                  "annualFuel": {
                    "label":newLabels?.rail?.annualFuel,
                    "info":newLabels?.railHint?.AnnualFuelConsDesc,
                    "type": "number",
                    "step":0.1,
                    "min": 0,
                  },
                  "units": {
                    "label":newLabels?.rail?.units,
                    "info":newLabels?.railHint?.UnitsFuelDesc,
                    "type": "string",
                     "options": unitsAdmin(lng) 
                  },
                    "notes": {
                      "label":newLabels?.rail?.notes,
                      "info":newLabels?.railHint?.NotesDesc2,
                      
                      
                      "type": "string",
                       
                  }
                },
                "required": ["ownership", "model", "engineYear", "fuelTypeTrain", "annualFuel", "units"]
                }      
              }
            }
            
          },
          "tables": {
            "hidden":true,
            "formTitle":newLabels?.app?.tables,
            "type": "array",
            "label":newLabels?.app?.tables,
            "meta":{"ui":"tables"},
            "items": {
              "type":"object",
              "properties":{
                "id": {
                  "label":newLabels?.app?.id,
                  "type": "string",     
                  "format": "uuid",     
                },
                "default": {                  
                  "type": "string",                            
                },
                "custom": {                  
                  "type": "string",                            
                },
              }
      
            }
            
          },
          
        },
        "required": ["introduction"]
      },
      "output":{
        "type":"object",
        "label":newLabels?.app?.output,
        "meta":{"ui":"dash"},
        
        "hide":true,
        "hidden":true,        
        "properties": {                   
          "item":{"type":"object"},
          // "data":{"type":"array"},
        }
      }
      
  
    },
    "required": ["id", "input","name"]
  }
}
}